module.exports = __webpack_public_path__ + "img/4_ru.4014fe27.jpg";